module.exports = __webpack_public_path__ + "static/media/customer-winkles.ceb15687.png";